import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";



// BELL_MT is passed in from invoice.jsx (the same constant the receipt always used).
export default function InvoiceReceipt({ invoiceDetail, BELL_MT }) {
  return (
    <>
              
              <Box id="receipt-content" sx={{ display: 'none', displayPrint: 'block', fontFamily: BELL_MT }}>
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                  <Typography sx={{ fontSize: 28, fontWeight: 900, letterSpacing: 4, color: '#000', fontFamily: BELL_MT }}>LEON GALLERY</Typography>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, fontFamily: BELL_MT }}>EUROVILLA 1, MAKATI CITY</Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 800, mt: 1, fontFamily: BELL_MT }}>OFFICIAL RECEIPT</Typography>
                  <Box sx={{ width: '40px', height: '2px', bgcolor: '#000', mx: 'auto', mt: 1 }} />
                </Box>

                <Grid container spacing={2} sx={{ mb: 4, borderBottom: '1px solid #000', pb: 2 }}>
                  <Grid item xs={7}>
                    <Typography sx={{ fontSize: 10, color: '#666', fontFamily: BELL_MT }}>CUSTOMER:</Typography>
                    <Typography sx={{ fontSize: 16, fontWeight: 800, fontFamily: BELL_MT }}>{invoiceDetail.data.customer_name || "Valued Client"}</Typography>
                  </Grid>
                  <Grid item xs={5} textAlign="right">
                    <Typography sx={{ fontSize: 10, color: '#666', fontFamily: BELL_MT }}>INVOICE NO:</Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 700, fontFamily: BELL_MT }}>#{invoiceDetail.data.invoice_no}</Typography>
                    <Typography sx={{ fontSize: 11, fontFamily: BELL_MT }}>Date: {new Date().toLocaleDateString()}</Typography>
                  </Grid>
                </Grid>

                <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'Bell MT, serif' }}>
                  <thead>
                    <tr style={{ borderBottom: '2px solid black', textAlign: 'left' }}>
                      <th style={{ padding: '10px 5px', fontSize: '11px' }}>ITEM</th>
                      <th style={{ padding: '10px 5px', fontSize: '11px' }}>DESCRIPTION</th>
                      <th style={{ padding: '10px 5px', fontSize: '11px', textAlign: 'right' }}>AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceDetail.lot?.map((lot) => (
                      <tr key={lot.id} style={{ borderBottom: '1px solid #eee' }}>
                        <td style={{ padding: '10px 5px', width: '80px' }}>
                          <img src={lot.img_url} alt="" style={{ width: '60px', height: '60px', objectFit: 'contain' }} />
                        </td>
                        <td style={{ padding: '10px 5px' }}>
                          <Typography sx={{ fontSize: 10, color: '#666', fontFamily: BELL_MT }}>Lot #{lot.lot_number}</Typography>
                          <Typography sx={{ fontSize: 13, fontWeight: 800, fontFamily: BELL_MT }}>{lot.title}</Typography>
                          <Typography sx={{ fontSize: 11, fontFamily: BELL_MT }}>{lot.artist}</Typography>
                        </td>
                        <td style={{ padding: '10px 5px', textAlign: 'right' }}>
                          <Typography sx={{ fontSize: 13, fontWeight: 800, fontFamily: BELL_MT }}>₱{Number(lot.total_price).toLocaleString()}</Typography>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
                  <Box sx={{ width: '220px', borderTop: '2px solid black', pt: 1 }}>
                    <Stack direction="row" justifyContent="space-between" sx={{ mb: 1 }}>
                      <Typography sx={{ fontSize: 12, fontFamily: BELL_MT }}>Subtotal:</Typography>
                      <Typography sx={{ fontSize: 12, fontFamily: BELL_MT }}>₱{Number(invoiceDetail.data.total_amount).toLocaleString()}</Typography>
                    </Stack>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography sx={{ fontSize: 16, fontWeight: 900, fontFamily: BELL_MT }}>TOTAL:</Typography>
                      <Typography sx={{ fontSize: 16, fontWeight: 900, fontFamily: BELL_MT }}>₱{Number(invoiceDetail.data.total_amount).toLocaleString()}</Typography>
                    </Stack>
                  </Box>
                </Box>
                
                <Box sx={{ mt: 8, textAlign: 'center', fontSize: 10, color: '#666' }}>
                  <Typography sx={{ fontSize: 10, fontFamily: BELL_MT }}>Thank you for your purchase.</Typography>
                  <Typography sx={{ fontSize: 9, fontFamily: BELL_MT }}>Leon Gallery Fine Art & Antiques</Typography>
                </Box>
              </Box>
    </>
  );
}
